var __jsx = React.createElement;
import React from "react";
import { ELSButton } from "components/common/elsevier/Button/Button";
import CalendarIcon from "components/common/elsevier/Icons/CalendarIcon";
import Styles from "../Styles.module.scss";
function AddDateRange(_ref) {
  var onClick = _ref.onClick,
    toggleYearState = _ref.toggleYearState;
  return /*#__PURE__*/React.createElement(ELSButton, {
    type: "button",
    "aria-label": "add date range",
    className: "es-link__black--16-font ".concat(Styles.button, " ").concat(toggleYearState ? "hide" : "show-inline-flex"),
    onClick: onClick,
    "data-cy": "add-year-range"
  }, /*#__PURE__*/React.createElement(CalendarIcon, null), /*#__PURE__*/React.createElement("span", {
    "data-cy": "add-year-range-text"
  }, "Add year range"));
}
export default AddDateRange;